import React from "react"
import "./policy.scss"
import productPageImg from "../../../../assets/website-images/product/bio-page-banner.png";
import productBannerImg from "../../../../assets/website-images/product/product-banner.jpg";
import PageBanner from "../../../components/website/pages-banner/PageBanner";
import {Col, Container, Row} from "react-bootstrap";
import {useTranslation} from "react-i18next";

export default function PrivacyPolicy() {
    const {t} = useTranslation();
    return(
        <div className={'policy'}>
            <PageBanner img={productPageImg} heading={t('terms_and_contidion.main_head')} bannerImg={productBannerImg}/>
            <div className={'section-3'}>
                <Container>
                    <Row>
                        <Col lg={12} xl={12}>
                            {/*<h3>{t('terms_and_contidion.main_head')}</h3>*/}
                            <h4>{t('terms_and_contidion.head_1')}</h4>
                            <p>{t('terms_and_contidion.para_1')}</p>
                            <h4>{t('terms_and_contidion.head_2')}</h4>
                            <p>{t('terms_and_contidion.para_2')}</p>
                            <ul>
                                <li>{t('terms_and_contidion.list_1')}</li>
                                <li>{t('terms_and_contidion.list_2')}</li>
                                <li>{t('terms_and_contidion.list_3')}</li>
                                <li>{t('terms_and_contidion.list_4')}</li>
                            </ul>
                            <h4>{t('terms_and_contidion.head_3')}</h4>
                            <p>{t('terms_and_contidion.para_3')}</p>
                            <h4>{t('terms_and_contidion.head_4')}</h4>
                            <p>{t('terms_and_contidion.para_4')}</p>
                            <h4>{t('terms_and_contidion.head_5')}</h4>
                            <p>{t('terms_and_contidion.para_5')}</p>
                            <h4>{t('terms_and_contidion.head_6')}</h4>
                            <p>{t('terms_and_contidion.para_6')}</p>
                            <h4>{t('terms_and_contidion.head_7')}</h4>
                            <p>{t('terms_and_contidion.para_7')}</p>
                            <p>{t('terms_and_contidion.para_8')}</p>
                            <p className={'mb-0'}>{t('terms_and_contidion.para_9')}</p>
                            <a href="mailto:info@utrust.sa">info@utrust.sa</a>
                            {/*<p>Welcome to <b>uTrust!</b> </p>*/}
                            {/*<p>These terms and conditions outline the rules and regulations for the use of Company Name's Website, located at Website.com.*/}
                            {/*</p>*/}
                            {/*<p>By accessing this website we assume you accept these terms and conditions. Do not continue to use Website Name if you do not agree to take all of the terms and conditions stated on this page.*/}
                            {/*</p>*/}
                            {/*<p>The following terminology applies to these Terms and Conditions, Privacy Statement and Disclaimer Notice and all Agreements: “Client”, “You” and “Your” refers to you, the person log on this website and compliant to the Company's terms and conditions. “The Company”, “Ourselves”, “We”, “Our” and “Us”, refers to our Company. “Party”, “Parties”, or “Us”, refers to both the Client and ourselves. All terms refer to the offer, acceptance and consideration of payment necessary to undertake the process of our assistance to the Client in the most appropriate manner for the express purpose of meeting the Client's needs in respect of provision of the Company's stated services, in accordance with and subject to, prevailing law of Netherlands. Any use of the above terminology or other words in the singular, plural, capitalization and/or he/she or they, are taken as interchangeable and therefore as referring to same.*/}
                            {/*</p>*/}
                            {/*<h4>Cookies</h4>*/}
                            {/*<p>We employ the use of cookies. By accessing Website Name, you agreed to use cookies in agreement with the Company Name's Privacy Policy.*/}
                            {/*</p>*/}
                            {/*<p>Most interactive websites use cookies to let us retrieve the user's details for each visit. Cookies are used by our website to enable the functionality of certain areas to make it easier for people visiting our website. Some of our affiliate/advertising partners may also use cookies.*/}
                            {/*</p>*/}
                            {/*<h4>License</h4>*/}
                            {/*<p>We employ the use of cookies. By accessing Website Name, you agreed to use cookies in agreement with the Company Name's Privacy Policy.*/}
                            {/*</p>*/}
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    )
}